module.exports = __webpack_public_path__ + "static/media/tailored-guidance.b945d642.png";